import axios from "./axiosInstance";

const AuthAPI = {
  forgotPassword: (payload) => axios.post("auth/forgot-password", payload),
  resetPasswordToken: (payload) =>
    axios.post("auth/verify-reset-token", payload),

  resetPassword: (token, payload) =>
    axios.post(`auth/reset-password?token=${token}`, payload),

  // token required wale endpoints
  getProfile: () => axios.get("auth/profiles"),
  
  updateProfile: (payload) => axios.put("auth/profiles", payload),
  
  updatePassword: (payload) => axios.post("auth/update-password", payload),

  updateStatus: (payload) => axios.post("auth/update-status", payload),
  
  delete: (payload) => axios.post("auth/delete", payload),

  login: (payload) => axios.post("auth/login", payload),

  logOut: () => axios.post("auth/logout"),

  uploadFile: (payload) => axios.post("assets/presign/tenant", payload),

  deleteFile: (params) => axios.delete("assets/delete/tenant", { params }),

  refreshToken: () => axios.post("auth/refresh-token", {}, {
    withCredentials: true,
  }),
};

export default AuthAPI;
